import Util from '../../script/util';
import HTTP from '../../script/service';
import { message, Modal } from 'antd';
import { debounce } from "lodash-es";
import store from '../store';
import { _anly_seng_custom } from '../Action';

const errorMessage = {
  0: '执行成功',
  '-1': '一般性的错误（没有明确归类的错误原因）。',
  '-2': '使用了无效的参数。,例如指定的频道名含有非法字符。',
  '-3': 'RTC 引擎初始化失败。',
  '-4': 'RTC 引擎当前状态不支持此项操作。',
  '-5': '调用被拒绝。',
  '-6': '传入的缓冲区大小不足以存放返回的数据。',
  '-7': 'SDK 尚未初始化就调用其 API。',
  '-9': '没有操作权限。',
  '-10': 'API 调用超时。',
  '-11': '请求被取消。',
  '-12': '调用频率太高。',
  '-13': 'SDK 内部绑定到网络 Socket 失败。',
  '-14': '网络不可用。',
  '-15': '没有网络缓冲区可用。',
  '-17': '加入频道被拒绝。,一般有以下原因：',
  '-18': '离开频道失败。,一般有以下原因：',
  '-19': '资源已被占用，不能重复使用。',
  '-20': 'SDK 放弃请求，可能由于请求次数太多。',
  '-21': 'Windows 下特定的防火墙设置导致 SDK 初始化失败然后崩溃。',
  '-22':
    '当用户 App 占用资源过多，或系统资源耗尽时，SDK 分配资源失败会返回该错误。',
  '-101': '不是有效的 App ID。',
  '-102': '不是有效的频道名。',
  '-109': 'DEPRECATED 请改用 ConnectionChangeReason 中的 9。',
  '-110': 'DEPRECATED 请改用 ConnectionChangeReason 中的 8。',
  '-113': '用户不在频道内。',
  '-114':
    '调用 sendStreamMessage，当发送的数据长度大于 1024 个字节时，会发生该错误。',
  '-115':
    '调用 sendStreamMessage，当发送的数据频率超过限制时（6 KB/s），会发生该错误。',
  '-116':
    '调用 createDataStream，如果创建的数据通道过多（超过 5 个），会发生该错误。',
  '-117': '数据流发送超时。',
  '-119': '切换角色失败。',
  '-120': '解密失败，可能是用户加入频道用了不同的密码。',
  '-123': '此用户被服务器禁止。',
  '-124': '水印文件参数错误。',
  '-125': '水印文件路径错误。',
  '-126': '水印文件格式错误。',
  '-127': '水印文件信息错误。',
  '-128': '水印文件数据格式错误。',
  '-129': '水印文件读取错误。',
  '-130':
    '调用 addPublishStreamUrl 时，如果开启了加密，则会返回该错误(推流不支持加密流)。',
  '-134': '无效的 User Account。',
  '-151': 'CDN 相关错误。',
  '-152': '单个主播的推流地址数目达到上限 10。',
  '-153': '操作不属于主播自己的流，如更新其他主播的流参数、停止其他主播的流。',
  '-154': '推流服务器出现错误。',
  '-155': '服务器无法找到数据流。',
  '-156': '推流地址格式有错误。',
  '-401': '用户已登出。',
  '-402': '网络故障。',
  '-403': '已在另一台设备登录。',
  '-405': 'Token 已过期。',
  '-1001': '加载媒体引擎失败。',
  '-1002': '启动媒体引擎开始通话失败。',
  '-1003': 'DEPRECATED 请改用 localVideoStateChanged 回调中的 error (4)。',
  '-1004': '启动视频渲染模块失败。',
  '-1005': '音频设备模块：音频设备出现错误（未明确指明为何种错误）。',
  '-1006': '音频设备模块：使用 Java 资源出现错误。',
  '-1007': '音频设备模块：设置的采样频率出现错误。',
  '-1008': '音频设备模块：初始化播放设备出现错误。',
  '-1009': '音频设备模块：启动播放设备出现错误。',
  '-1010': '音频设备模块：停止播放设备出现错误。',
  '-1011': '音频设备模块：初始化录音设备时出现错误。',
  '-1012': '音频设备模块：启动录音设备出现错误。',
  '-1013': '音频设备模块：停止录音设备出现错误。',
  '-1015': '音频设备模块：运行时播放出现错误。',
  '-1017': '音频设备模块：运行时录音错误。',
  '-1018': '音频设备模块：录音失败。',
  '-1020': '音频设备模块：回放频率异常。',
  '-1021': '音频设备模块：录制频率异常。',
  '-1022': '音频设备模块：初始化 Loopback 设备错误。',
  '-1023': '音频设备模块：启动 Loopback 设备错误。',
  '-1027': '音频设备模块：没有录音权限。',
  '-1033': '音频设备模块：录制设备被占用。',
  '-1301': '音频设备模块：音频驱动异常或者兼容性问题。',
  '-1303': '音频设备模块：音频驱动异常或者兼容性问题。',
  '-1306': '音频设备模块：音频驱动异常或者兼容性问题。',
  '-1307': '音频设备模块：无可用音频设备。',
  '-1309': '音频设备模块：音频驱动异常或者兼容性问题。',
  '-1311': '音频设备模块：系统内存不足或者机器性能较差。',
  '-1314': '音频设备模块：音频驱动异常。',
  '-1319': '音频设备模块：系统内存不足或者机器性能较差。',
  '-1320': '音频设备模块：音频驱动异常。',
  '-1322': '音频设备模块：无可用音频采集设备。',
  '-1323': '音频设备模块：无可用音频播放设备。',
  '-1351': '音频设备模块：音频驱动异常或者兼容性问题。',
  '-1353': '音频设备模块：音频驱动异常。',
  '-1354': '音频设备模块：音频驱动异常。',
  '-1355': '音频设备模块：音频驱动异常。',
  '-1356': '音频设备模块：音频驱动异常。',
  '-1357': '音频设备模块：音频驱动异常。',
  '-1358': '音频设备模块：音频驱动异常。',
  '-1359': '音频设备模块：无录制设备。',
  '-1360': '音频设备模块：无播放设备。',
  '-1501': '视频设备模块：没有摄像头使用权限。',
  '-1502': 'DEPRECATED 请改用 localVideoStateChanged 回调中的 error (3)。',
  '-1600': '视频设备模块：未知错误。',
  '-1601': '视频设备模块：视频编码器初始化错误。',
  '-1602': '视频设备模块：视频编码器错误。',
  '-1603': '视频设备模块：视频编码器设置错误。',
};

class AgoraElectronRTC {
  constructor(room) {
    this.isInit = false; // 是否已初始化
    this.room = null; // 初始化时的房间参数
    this.liveConfig = null; // 房间配置
    this.events = {}; // 对应事件

    this.isAgoraRTC = false; // 是否是声网
    this.token = null;
    this.client = null;
    this.joined = false;
    this.published = false;
    this.localStream = null;
    this.remoteStreams = [];
    this.params = {};
    this.device_list = [];
    this.mic_list = [];
    this.liveConfig = {};
    this.audioVolume = 100; //伴奏音量
    this.playVolume = 100; //扬声器音量
    this.speakVolume = 255; //麦克风音量
    this.disAudio = false; //是否被静音

    // electron 获取的即构实例
    this.client = window.eleEvents.agoraElectronRTC.rtcEngine;
    this.logPath = window.eleEvents.agoraElectronRTC.sdkLogPath;
    this.AudioDeviceManager = this.client.getAudioDeviceManager();

    this.room = room; // 房间信息
    this.liveConfig = room.liveConfig || {};
    this.hookPlugin = null;
  }

  async openConn() {
    if (!this.isInit) {
      await this.initClient();

      // RTC初始化完成，开始加载即构小游戏
      this.room.events['RTC_INIT_END'] &&
        this.room.events['RTC_INIT_END'](this);
      this.isInit = true;
      this.setSysConfig();
      this.bindEvent();
      this.getDevices().then(() => this.joinChannel());
    } else {
      // RTC初始化完成，开始加载即构小游戏
      this.room.events['RTC_INIT_END'] &&
        this.room.events['RTC_INIT_END'](this);

      this.setSysConfig();
      await this.joinChannel();
    }

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: true}});
  }

  // 初始化加载
  async initClient(callback) {
    this.remoteStreams = [];
    this.default_mic = null;
    this.default_div = null;
    this.audio_state = false; //伴奏状态
    this.dev_state = true; //扬声器状态
    this.mic_state = true; //麦克风状态
    this.disAudio = false; //是否被静音
    this.wifiDown = document.querySelector('#wifi-down'); // 拉流质量
    this.wifiUp = document.querySelector('#wifi-up'); // 推流质量

    const instance = await Util.getAssemblyInstance();
    const { getAgoraAppID } = instance.exports;
    const code = this.client.initialize({
      appId: getAgoraAppID(process.env.CLIENT_ENV),
      logConfig: { filePath: this.logPath },
    });
    if (code === 0) {
      callback && callback();
    } else {
      console.error('声网 SDK 初始化失败', code);
    }
  }

  // 获取token
  getToken() {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await HTTP._get_agora_token({
          uid: this.room.uid || 0,
          channelName: this.room.roomid,
        });
        if (result?.code === 200) {
          this.token = result.data.token;
          resolve(true);
        } else {
          reject(result);
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  // 初始化配置
  setSysConfig() {
    // 设置日志等级
    this.client.setLogLevel(0x0004);
    //设置直播场景
    this.client.setChannelProfile(1);
    //关闭视频模块
    this.client.disableVideo();
    //设置角色
    this.client.setClientRole(2);
    if (this.audioHookEnabled) {
      this.handleAudioHook();
    }
    //启用音量提示
    this.client.enableAudioVolumeIndication(3000, 3, true);
    //还原变声
    this.setAudioEffectPreset(0);
    //还原美音
    this.setVoiceBeautifierPreset(0);

    // 音质设置 统一使用高音质
    this.client.setAudioProfile(5, 3); // 高清
    // 是否开启高音质
    this.client.setParameters(
      JSON.stringify({ 'che.audio.specify.codec': 'HEAAC_2ch' })
    );
    this.client.setParameters(
      JSON.stringify({ 'che.audio.codec.bitrate': '64000' })
    );
    // 回声消除、降噪、增益
    this.client.setParameters(JSON.stringify({ 'che.audio.enable.aec': true }));
    this.client.setParameters(JSON.stringify({ 'che.audio.enable.ns': true })); // todo 以往没传该字段疑问
    this.client.setParameters(JSON.stringify({ 'che.audio.enable.agc': true }));
  }

  // 监听事件
  bindEvent() {
    const bindEventHandle = new BindEventHandle(this);
    this.client.registerEventHandler(bindEventHandle);
  }

  // 加入房间
  async joinChannel() {
    try {
      await this.getToken();
      this.setDefaultDevices();
      const code = this.client.joinChannel(
        this.token,
        this.room.roomid,
        Number(this.room.uid),
        {
          autoSubscribeAudio: true,
          enableAudioRecordingOrPlayout: true,
          ClientRoleAudience: 2,
        }
      );
      if (code === 0) {
        this.joined = true;
        this.dev_state = true;
        //默认开启扬声器
        this.room.events['CHANGE_DEV_STATE'] &&
          this.room.events['CHANGE_DEV_STATE'](true, this.playVolume);
      } else {
        console.error('加入房间失败', code);
      }
    } catch (err) {
      console.error('join room error:', err);
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: '进入当前房间失败，请重试',
        className: 'daidai-confirm-style',
        cancelText: '返回',
        okText: '确定',
        centered: true,
        onOk: () => {
          window.location.reload(true);
        },
        onCancel: () => {
          window.location.href = '/index?' + window.location.search;
        },
      });
    }
  }

  // 获取设备
  getDevices() {
    return new Promise((resolve, reject) => {
      this.mic_list = this.AudioDeviceManager.enumerateRecordingDevices();
      this.device_list = this.AudioDeviceManager.enumeratePlaybackDevices();
      resolve();
    });
  }

  // 设置默认设备
  setDefaultDevices() {
    this.audioVolume = 100;
    this.playVolume = 100;
    this.speakVolume = 255;
    this.audioModal = 1;
    //伴奏音量
    let audioVolume = Util.readCookie('audioVolume');
    if (audioVolume && !isNaN(audioVolume)) {
      this.audioVolume = parseInt(audioVolume);
    }
    //扬声器音量
    let playVolume = Util.readCookie('playVolume');
    if (playVolume && !isNaN(playVolume)) {
      this.playVolume = parseInt(playVolume);
    }
    //麦克风音量
    let speakVolume = Util.readCookie('speakVolume');
    if (speakVolume && !isNaN(speakVolume)) {
      this.speakVolume = parseInt(speakVolume);
    }
    //播放器模式
    let audioModal = Util.readCookie('audioModal');
    if (audioModal && !isNaN(audioModal)) {
      this.audioModal = parseInt(audioModal);
    }
    //设置默认设备
    let def_d = Util.readCookie('default_div_electron');
    if (def_d) {
      this.default_div = JSON.parse(def_d);
    } else {
      this.default_div = this.device_list[0];
    }
    let def_m = Util.readCookie('default_mic_electron');
    if (def_m) {
      const localJson = Util.isJSONStr(def_m) ? JSON.parse(def_m) : null;
      const find = this.mic_list.find(
        (item) => item.deviceId === localJson.deviceId
      );
      if (find) {
        this.default_mic = find;
      } else {
        this.default_mic = this.mic_list[0];
      }
    } else {
      this.default_mic = this.mic_list[0];
    }
    if (this.room.events['INIT_DEFAULT_PARAM']) {
      this.room.events['INIT_DEFAULT_PARAM']({
        audioVolume: this.audioVolume,
        playVolume: this.playVolume,
        speakVolume: this.speakVolume,
      });
    }
  }

  // 更新直播队列
  getLiveConfig() {
    return new Promise((resolve, reject) => {
      //直播上报
      HTTP._mixed_channel_create({
        uid: this.room.uid,
        roomid: this.room.roomid,
        roomcid: this.room.roomid,
        creator: this.room.account,
      });
      const { rootConfig } = store.getState();
      //如果直播已经存在
      if (this.room.hasLive()) {
        this.liveConfig = {
          channelName: this.room.roomid, //房间名称
          channelId: null, //通话渠道 由网易返回
          creator: this.room.account, //直播创建者
          cid: null, //通话cid标识 由接口返回
          pushUrl: null, //推流地址
          rtmpPullUrl: null, //拉流地址
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: this.room.base.clientInfo.version, //pc独有版本参数
          master_type: this.room.base.client, //主播当前终端类型
          config: [...this.room.liveConfig.config], //麦位属性配置
        };
      } else {
        this.liveConfig = {
          channelName: this.room.roomid, //房间名称
          channelId: null, //通话渠道 由网易返回
          creator: this.room.account, //直播创建者
          cid: null, //通话cid标识 由接口返回
          pushUrl: null, //推流地址
          rtmpPullUrl: null, //拉流地址
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: this.room.base.clientInfo.version, //pc独有版本参数
          master_type: this.room.base.client, //主播当前终端类型
          config: [], //麦位属性配置
        };
        for (let i = 0; i < 9; i++) {
          this.liveConfig.config.push({
            index: i, //麦位
            type: i == 0 ? 0 : 1, //类型  0 主播位置 1 互动位  2 老板位
            enabled: true, // 是否启用用位置
            microphone: true, // 是否启用麦克风
            disAudio: false, //是否被静音
          });
        }
      }
      //2、发送麦位配置
      this.room.modifyConfig(this.liveConfig, false, () => {
        //3、发送1-1指令
        this.room.sendCustomMsg({
          action: '1-1',
          creator: this.room.account,
        });
        resolve();
      });
    });
  }
  // 成功上麦
  joinSuccess(callback) {
    this.published = true;
    this.room.queuePoll(`queue_${this.room.uid}`);
    //如果当前在相亲模式-并且游戏进行中, 用户需要上报
    if (
      this.room.roomInfo &&
      this.room.roomInfo.custom &&
      this.room.roomInfo.custom.rmode == 1 &&
      this.room.datingData &&
      this.room.datingData.sdata
    ) {
      HTTP._addDataingUser({
        roomid: this.room.roomid,
        uids: this.room.uid,
      });
    }
    //派单房, 用户需要上报 todo 2.21.3 更改为所有房间都上报
    if (this.room.base.microType === 0) {
      if (this.room.roomInfo && this.room.roomInfo.custom) {
        let meque = this.room.queueObject[this.room.account];
        let msgId = null;
        if (
          this.room.roomInfo.custom.rmode == 6 &&
          this.room.sendOrders &&
          this.room.sendOrders.msgId
        ) {
          msgId = this.room.sendOrders.msgId;
        }
        if (meque) {
          HTTP._oneorder_upMicrophone({
            uid: this.room.uid,
            roomId: this.room.roomid,
            index: meque.index,
            msgId,
          });
        }
      }
    }
    // 设置混音音量
    this.setAudioVolume(this.audioVolume);

    // window 客户端状态栏缩略图
    window.eleEvents?.setThumbarPlay && window.eleEvents.setThumbarPlay('play');

    callback && callback();
  }

  //播放音乐文件
  startAudioMixing(music, callback) {
    this.events['audioMixingStateChanged'] = callback;
    return new Promise(async (resolve) => {
      this.playMusic = music;
      let code = this.client.startAudioMixing(music.url, false, 1, 0);
      resolve(code);
    });
  }
  // 暂停播放
  pauseAudioMixing = () => {
    const code = this.client.pauseAudioMixing();
    if (code !== 0) {
      console.error('pauseAudioMixing error:', code);
      if (errorMessage[code]) {
        message.warning(errorMessage[code]);
      }
    }
  };
  // 恢复播放
  resumeAudioMixing = () => {
    const code = this.client.resumeAudioMixing();
    if (code !== 0) {
      console.error('resumeAudioMixing error:', code);
      if (errorMessage[code]) {
        message.warning(errorMessage[code]);
      }
    }
  };

  // 开启本地扬声器设备
  changeVoiceState = ({ open, operateSource = false }) => {
    if (this.isGameing && this.isGameOperateSpeaker && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return false;
    }
    this.isGameOperateSpeaker = operateSource;
    this.dev_state = open;
    const code = this.client.muteAllRemoteAudioStreams(!this.dev_state);
    if (code === 0) {
      this.room.events['CHANGE_DEV_STATE'] &&
        this.room.events['CHANGE_DEV_STATE'](open, this.playVolume);
    } else {
      if (errorMessage[code]) {
        message.error(errorMessage[code]);
      }
    }
  };
  // 开启本地麦克风设备
  changeMicState = ({ open, operateSource = false, callback = null }) => {
    if (this.isGameing && this.isGameOperateMic && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return false;
    }
    this.isGameOperateMic = operateSource;
    this.mic_state = open;
    this.room.events['CHANGE_MIC_STATE'] &&
      this.room.events['CHANGE_MIC_STATE'](this.mic_state, this.speakVolume);
    if (this.localStream) {
      const code = this.client.muteLocalAudioStream(!this.mic_state);
      if (code !== 0) {
        if (errorMessage[code]) {
          message.error(errorMessage[code]);
        }
      }
    }
    callback && callback();
  };
  // 切换扬声器
  changeVoiceValue = (dev) => {
    if (this.isGameing && this.isGameOperateSpeaker) {
      message.warning('游戏中无法切换扬声器');
      return;
    }

    this.default_div = dev;
    this.dev_state = true;
    const code = this.AudioDeviceManager.setPlaybackDevice(
      this.default_div.deviceId
    );
    if (code === 0) {
      Util.setCookie('default_div_electron', JSON.stringify(this.default_div));
      this.room.events['CHANGE_DEV_STATE'] &&
        this.room.events['CHANGE_DEV_STATE'](true, this.playVolume);
    } else {
      if (errorMessage[code]) {
        message.error(errorMessage[code]);
      }
    }
  };
  // 切换麦克风
  changeVoiceSpeak = (mic) => {
    if (this.isGameing && this.isGameOperateMic) {
      message.warning('游戏中无法切换麦克风');
      return;
    }

    if (this.client) {
      this.default_mic = mic;
      this.mic_state = true;
      if (this.AudioDeviceManager?.setRecordingDevice) {
        const code =
          this.AudioDeviceManager.setRecordingDevice(
            this.default_mic.deviceId
          ) ?? -1;
        if (code === 0) {
          Util.setCookie(
            'default_mic_electron',
            JSON.stringify(this.default_mic)
          );
          this.room.events['CHANGE_MIC_STATE'] &&
            this.room.events['CHANGE_MIC_STATE'](true, this.speakVolume);
        } else {
          if (errorMessage[code]) {
            message.error(errorMessage[code]);
          }
        }
      } else {
        message.info('切换麦克风失败');
      }
    }
  };
  // 设置伴奏音量
  setAudioVolume = (volume) => {
    this.audioVolume = volume;
    Util.setCookie('audioVolume', volume);
    this.client.adjustAudioMixingVolume(this.audioVolume);
  };
  // 设置伴奏模式
  changePlayModel = (m) => {
    this.audioModal = m;
    Util.setCookie('audioModal', m);
  };
  // 设置伴奏播放音量
  changeAudioMute = (n) => {
    this.client.adjustAudioMixingVolume(n ? 0 : this.audioVolume);
  };
  // 设置扬声器音量
  setPlayVolume = (volume, callback = null) => {
    if (this.isGameing && this.isGameOperateSpeaker) {
      message.warning('游戏中无法调节扬声器音量');
      callback && callback(false);
      return;
    }
    this.dev_state = true;
    this.playVolume = volume;
    Util.setCookie('playVolume', volume);
    this.client.adjustPlaybackSignalVolume(this.playVolume);
    callback && callback(true);
  };
  // 设置麦克风音量
  setSpeakVolume = (volume, callback = null) => {
    if (this.isGameing && this.isGameOperateMic) {
      message.warning('游戏中无法调节麦克风音量');
      callback && callback(false);
      return;
    }
    this.mic_state = true;
    this.speakVolume = volume;
    Util.setCookie('speakVolume', volume);
    this.client.adjustRecordingSignalVolume(this.speakVolume);
    callback && callback(true);
  };
  // 解除禁言
  changeRoleToPlayer = () => {
    this.client.muteLocalAudioStream(false);
    this.published = true;
    this.disAudio = false;
  };
  // 被禁言
  changeRoleToAudience = () => {
    this.client.muteLocalAudioStream(true);
    this.published = false;
    this.disAudio = true;
  };

  // 上麦
  publishLocalStream = (queue) => {
    if (this.slefStream) return;
    return new Promise((resolve, reject) => {
      this.index = queue.index;
      window.ddElectron.checkAndApplyDeviceAccessPrivilege(); // 检测麦克风权限
      if (!this.mic_list.length) {
        this.room.closeLoading && this.room.closeLoading();
        message.error(
          '未检出到你的电脑上有麦克风设备，请检查正确安装/打开后再试。'
        );
        reject();
      } else {
        this.slefStream = true;
        const code = this.client.setClientRole(1);
        // 开启本地音频推送
        if (this.disAudio) {
          this.disAudio = false;
          this.AudioDeviceManager.muteLocalAudioStream(false);
        }
        //开启本地音频采集
        this.openLocalAudio = true;
        this.client.enableLocalAudio(true);
        // 设置默认采集音量
        this?.AudioDeviceManager?.setRecordingDeviceVolume &&
          this.AudioDeviceManager.setRecordingDeviceVolume(
            this.speakVolume || 255
          );
        // 设置默认麦克风设备
        this?.AudioDeviceManager?.setRecordingDevice &&
          this.AudioDeviceManager.setRecordingDevice(this.default_mic.deviceId);
        if (code === 0) {
          this.localStream = true;
          if (this.index == 0) {
            this.getLiveConfig().then(() => {
              this.joinSuccess();
            });
          } else {
            this.joinSuccess();
          }
          // 设置麦克风状态
          this.changeMicState({ open: this.mic_state });
          // 设置麦克风音量
          this.client.adjustRecordingSignalVolume(this.speakVolume);

          resolve();
          //上麦标注
          this.room.events['CHANGE_UPINMIC_STATE'] &&
            this.room.events['CHANGE_UPINMIC_STATE'](true);
          //播放器参数初始化
          if (this.room.events['INIT_LOCAL_MUSIC_PARAM']) {
            this.room.events['INIT_LOCAL_MUSIC_PARAM']({
              audioModal: this.audioModal,
              audioVolume: this.audioVolume,
            });
          }
        } else {
          console.error('publishLocalStream error:', code);
          if (errorMessage[code]) {
            message.error(errorMessage[code]);
          }
          reject();
        }
      }
    });
  };
  // 下麦
  delToMic = (n) => {
    window.eleEvents?.setThumbarPlay &&
      window.eleEvents.setThumbarPlay('clear');
    // 下麦标注
    this.room.events['CHANGE_UPINMIC_STATE'] &&
      this.room.events['CHANGE_UPINMIC_STATE'](false);
    this.mic_state = true;
    // 关闭存在本地流
    if (this.localStream) {
      // 停止音乐播放
      if (this.playMusic) {
        this.client.stopAudioMixing();
        this.playMusic = null;
      }
      // 停止录音
      if (this.events['stopAudioRecordingCallback']) {
        this.events['stopAudioRecordingCallback'](
          '录音结束，文件已保存至文件夹'
        );
        this.stopAudioRecording();
      }

      const code = this.client.setClientRole(2);
      if (code === 0) {
        this.published = false;
        this.localStream = null;
        this.slefStream = false;
      }
    }
    // 删除自己的队列
    if (this.room.hasQueume()) {
      const { microType } = store.getState();
      if (microType === 0) {
        this.room.queuePoll(this.room.account);
      } else {
        HTTP._post_server_down_microphone({
          roomId: this.room.roomid,
          operationType: 0,
        });
      }
    }
    this.room.events['CHANGE_MIC_GAME_OVER'] &&
      this.room.events['CHANGE_MIC_GAME_OVER'](n);
  };
  // 销毁离开房间
  destroyRoom = (n) => {
    this.delToMic(3);
    // 离开房间
    if (!this.client) {
      message.error('销毁失败');
    } else {
      const code = this.client.leaveChannel();
      this.client.release();
      if (code === 0) {
        console.log('destroyRoom：', n);
        this.joined = false;
        this.localStream = null;
        this.remoteStreams = [];
        this.isAgoraRTC = false;
      } else {
        console.log('destroyRoom error：', n);
        this.joined = false;
        this.localStream = null;
        this.remoteStreams = [];
        this.isAgoraRTC = false;
      }
    }
    this.events = {};
    this.room.webrtc = null;

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: false}});
  };
  /**
   * 设置变声
   * @param {0} 关闭
   * @param {33686272} 男孩
   * @param {33686784} 女孩
   * @param {33687296} 绿巨人
   * @param {33686016} 老男孩
   * @param {33687040} 猪八戒
   * @param {33686528} 少女
   * @param {33685760} 大叔
   * @returns
   */
  setAudioEffectPreset = (value) => {
    return new Promise((resolve, reject) => {
      if (this.client.setAudioEffectPreset) {
        const code = this.client.setAudioEffectPreset(value);
        if (code === 0) {
          resolve({
            code: code,
            message: errorMessage[code],
          });
        } else {
          reject({
            code: code,
            message: errorMessage[code],
          });
        }
      } else {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      }
    });
  };
  /**
   * 设置美声音效
   * @param {0} 关闭
   * @param {16843264} 清新（女）
   * @param {16843008} 磁性（男）
   * @param {16843520} 活力（女）
   * @param {16908544} 歌唱美声
   * @param {16975360} 清澈
   * @param {16974336} 低沉
   * @param {16974848} 假音
   * @param {16975104} 饱满
   * @param {16974592} 圆润
   * @param {16975616} 高亢
   * @param {16975872} 嘹亮
   * @param {16974080} 浑厚
   * @returns
   */
  setVoiceBeautifierPreset = (value) => {
    return this.setAudioEffectPreset(value);
  };
  // 设置本地语音音调
  setLocalVoicePitch = (value) => {
    return new Promise((resolve, reject) => {
      if (this.client.setLocalVoicePitch) {
        const code = this.client.setLocalVoicePitch(value);
        if (code === 0) {
          resolve({
            code: code,
            message: errorMessage[code],
          });
        } else {
          reject({
            code: code,
            message: errorMessage[code],
          });
        }
      } else {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      }
    });
  };
  // 设置本地语音音效均衡
  setLocalVoiceEqualization = (value1, value2) => {
    return new Promise((resolve, reject) => {
      if (this.client.setLocalVoiceEqualization) {
        const code = this.client.setLocalVoiceEqualization(value1, value2);
        if (code === 0) {
          resolve({
            code: code,
            message: errorMessage[code],
          });
        } else {
          reject({
            code: code,
            message: errorMessage[code],
          });
        }
      } else {
        reject({
          code: 1,
          message: '客户端版本未升级',
        });
      }
    });
  };
  // 开始录音
  startAudioRecording(filePath, callback) {
    return new Promise((resolve, reject) => {
      filePath = filePath + '/' + +new Date() + '.wav';
      let code = this.client.startAudioRecording(
        {
          filePath,
          fileRecordingType: 3,
        },
        48000,
        1
      );
      if (code === 0) {
        this.events['stopAudioRecordingCallback'] = callback;
        resolve({
          code: code,
          message: errorMessage[code],
        });
      } else {
        reject({
          code: code,
          message: errorMessage[code],
        });
      }
    });
  }
  // 停止录音
  stopAudioRecording() {
    return new Promise((resolve, reject) => {
      this.events['stopAudioRecordingCallback'] = null;
      let code = this.client.stopAudioRecording();
      if (code == 0) {
        resolve({
          code: code,
          message: errorMessage[code],
        });
      } else {
        reject({
          code: code,
          message: errorMessage[code],
        });
      }
    });
  }
  /***
   * 游戏方操作闭麦开麦
   * */
  gameOperateRTC = {
    syncGameStatus: (bool = false) => {
      this.isGameing = bool;
      if (!bool) {
        this.isGameOperateMic = false;
        this.isGameOperateSpeaker = false;
      }
    },
    // 开麦
    openMicrophone: () => {
      if (this.client && this.isGameing && this.localStream) {
        this.isGameOperateMic = true;
        this.changeMicState({ open: true, operateSource: true });
      }
    },
    // 闭麦
    closeMicrophone: () => {
      if (this.client && this.isGameing && this.localStream) {
        this.isGameOperateMic = true;
        this.changeMicState({ open: false, operateSource: true });
      }
    },
    // 开启扬声器
    openSpeaker: () => {
      if (this.client && this.isGameing) {
        this.isGameOperateSpeaker = true;
        this.changeVoiceState({ open: true, operateSource: true });
      }
    },
    // 关闭扬声器
    closeSpeaker: () => {
      if (this.client && this.isGameing) {
        this.isGameOperateSpeaker = true;
        this.changeVoiceState({ open: false, operateSource: true });
      }
    },
  };
}
// 监听相关函数
class BindEventHandle {
  constructor(props) {
    this.props = props;
    this.client = props.client;
    this.volumeSpeakers = []; // 音浪暂存用户列表

    // 开启音浪回调
    this.client.enableAudioVolumeIndication(3000, 3, true);
  }

  // 成功加入房间
  onJoinChannelSuccess(channel, uid, elapsed) {
    if (!this.props.room.conn) {
      this.props.destroyRoom(3);
    } else {
      this.props.delToMic(2);
    }
  }
  // 离开房间
  onLeaveChannel(connection, stats) {
    // console.log('onLeaveChannel：', stats)
  }
  // 网络连接状态已改变回调
  onConnectionStateChanged(connection, state, reason) {
    // console.log('onConnectionStateChanged：', stateMsgArr[state], reasonMsgArr[reason]);
  }
  // 每个用户网络上下行 last mile 质量报告回调
  onNetworkQuality(connection, remoteUid, txQuality, rxQuality) {
    // 只判断自己
    if (remoteUid === 0) {
      let tx = Number(txQuality) + 1;
      if (tx === 0) tx = 1;
      if (tx > 5) tx = 0;
      if (this.props.wifiUp) this.props.wifiUp.className = 'w-up d-' + tx;

      let rx = Number(rxQuality) + 1;
      if (rx === 0) rx = 1;
      if (rx > 5) rx = 0;
      if (this.props.wifiDown) this.props.wifiDown.className = 'w-down d-' + rx;
    }
  }
  // token 即将过期
  async onTokenPrivilegeWillExpire(connection, token) {
    console.error('onTokenPrivilegeWillExpire: ', token);
    this.tokenWillExpireErrorCount += 1;
    if (this?.tokenWillExpireErrorCount > 10) {
      _anly_seng_custom(1105, {
        data: {
          token: this.props.token,
          oldTole: token,
          renewToken: 'true',
          count: this.tokenWillExpireErrorCount,
        },
      });

      this.tokenWillExpireErrorCount = 0;
    }

    try {
      await this.props.getToken();
      this.client.renewToken(this.props.room.roomid, this.props.token);
      this.tokenWillExpireErrorCount = 0;
    } catch (err) {
      _anly_seng_custom(1105, {
        data: { token: this.props.token, oldToken: token },
      });
      Modal.confirm({
        title: '系统提示',
        icon: null,
        closable: true,
        content: '你的token权限失效，请退出房间重现进入。',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk() {
          window.location.reload();
        },
        onCancel() {
          window.location.reload();
        },
      });
    }
  }
  // 音频设备变化回调
  onAudioDeviceStateChanged(deviceId, deviceType, deviceState) {
    console.log(
      '---onAudioDeviceStateChanged---',
      deviceId,
      deviceType,
      deviceState
    );
  }
  // 用户音量提示回调
  onAudioVolumeIndication(connection, speakers, speakerNumber, totalVolume) {
    this.volumeSpeakers.push(...speakers);
    this.changeVolume();
  }
  changeVolume = debounce(() => {
    const speakMembers = [];
    this.volumeSpeakers.forEach((item) => {
      let isSpeak = false;
      if (item.uid === 0) { // 我自己
        item.uid = this.props.room.uid;
      }
      if (item.volume > 10) isSpeak = true;

      speakMembers.push({
        uid: item.uid,
        roomid: this.props.room.roomid,
        isSpeak
      })
    });
    this.props.room.showSpeakUsers(speakMembers);

    this.volumeSpeakers = [];
  }, 2000);
  // 混音（伴奏）相关回调
  onAudioMixingStateChanged(state, error) {
    if (!this.props.playMusic) return;
    // error 0 成功打开音乐文件 701 文件打开出错 702 文件打开频繁
    // state 710 播放中 711 暂停播放 713 播放结束
    // playing 0: 不在播放 1: 播放中 2: 暂停播放 3: 播放结束
    const errorMsg = {
      0: '成功打开音乐文件',
      701: '音乐文件打开出错',
      702: '音乐文件打开太频繁',
      703: '音乐文件播放中断',
      721: '音乐文件完成一次循环播放',
      723: '音乐文件完成所有循环播放',
      724: '成功调用 stopAudioMixing 停止播放音乐文件',
    };
    if (state === 714 && (error === 701 || error === 702)) {
      this.props.playMusic.playing = false;
      this.props.events['audioMixingStateChanged'] &&
        this.props.events['audioMixingStateChanged'](
          this.props.playMusic,
          0,
          errorMsg[error]
        );
    }
    // 播放
    else if (state === 710) {
      this.props.playMusic.playing = true;
      this.props.playMusic.duration = this.client.getAudioMixingDuration();
      this.props.events['audioMixingStateChanged'] &&
        this.props.events['audioMixingStateChanged'](
          this.props.playMusic,
          1,
          null
        );
    }
    // 暂停播放
    else if (state === 711 || (state === 713 && error === 724)) {
      this.props.playMusic.playing = false;
      this.props.events['audioMixingStateChanged'] &&
        this.props.events['audioMixingStateChanged'](
          this.props.playMusic,
          2,
          null
        );
    }
    // 结束播放
    else if (state === 713 && error === 723) {
      this.props.playMusic.playing = false;
      this.props.events['audioMixingStateChanged'] &&
        this.props.events['audioMixingStateChanged'](
          this.props.playMusic,
          3,
          null
        );
    }
  }
  // 音乐文件播放进度回调
  onAudioMixingPositionChanged(position) {
    if (this.props.playMusic.playing) {
      // 播放中
      this.props.playMusic.position = position;
      this.props.events['audioMixingStateChanged'] &&
        this.props.events['audioMixingStateChanged'](
          this.props.playMusic,
          1,
          null
        );
    }
  }
}

export default AgoraElectronRTC;
